import { render, staticRenderFns } from "./suitch-chart-generic-widget.vue?vue&type=template&id=214bd8f0&"
import script from "./suitch-chart-generic-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-chart-generic-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports